export default "__VITE_ASSET__VvpJ9D6i__"